const superagent = require('superagent')
const R = require('ramda')
const RF = require('ramda-fantasy')
const errors = require('@mediatool/mt-errors/lib/errors')
const baseURL = require('./base-url')
const cookie = require('./cookie')

const { Maybe, Future } = RF
const originalNetworkMessage = 'Request has been terminated'
const newNetworkMessage = 'Network error, connection has been lost. Please check your network connectivity and refresh the page.'

function isAbsolute (url) {
  return url.indexOf('http') === 0
}

function createError (body) {
  const { message = '' } = body
  const errorName = body.name
  if (errors[errorName]) return new errors[errorName](body)
  if (message.startsWith(originalNetworkMessage)) return new Error(newNetworkMessage)

  return new Error(body.message)
}

function convertError (err) {
  if (err.response) { return createError(err.response.body) }
  return err
}

const addBase = R.concat(baseURL)
const buildURL = R.ifElse(isAbsolute, R.identity, addBase)

const invokeSet = R.invoker(2, 'set')
const addAuthTokenTo = R.flip(invokeSet('Authorization'))

function addAuth (request) {
  const authToken = Maybe(cookie.get('mtAuthToken'))
  return authToken.map(R.concat('Bearer ')).reduce(addAuthTokenTo, request)
}

module.exports = {

  del (uri) {
    return new Future((reject, resolve) => {
      addAuth(superagent.del(buildURL(uri)))
        .then(resolve, reject)
    })
      .bimap(convertError, R.identity)
  },

  get (uri) {
    return new Future((reject, resolve) => {
      addAuth(superagent.get(buildURL(uri)))
        .then(resolve, reject)
    }).bimap(convertError, R.identity)
  },

  getWithQuery: R.curry((uri, query) => new Future((reject, resolve) => {
    addAuth(superagent.get(buildURL(uri)))
      .query(query)
      .then(resolve, reject)
  })
    .bimap(convertError, R.identity)),

  post (uri) {
    return new Future((reject, resolve) => {
      addAuth(superagent.post(buildURL(uri)))
        .then(resolve, reject)
    })
      .bimap(convertError, R.identity)
  },

  postWithData: R.curry((uri, data) => new Future((reject, resolve) => {
    addAuth(superagent.post(buildURL(uri)))
      .send(data)
      .then(resolve, reject)
  })
    .bimap(convertError, R.identity)),

  put (uri) {
    return new Future((reject, resolve) => {
      addAuth(superagent.put(buildURL(uri)))
        .then(resolve, reject)
    })
      .bimap(convertError, R.identity)
  },

  putWithData: R.curry((uri, data) => new Future((reject, resolve) => {
    addAuth(superagent.put(buildURL(uri)))
      .send(data)
      .then(resolve, reject)
  })
    .bimap(convertError, R.identity)),

}
